/**
 * Ticker.js
 * -----------
 * requestAnimationFrame helper. Provides elapsed time between frames and a lag compensation multiplier to callbacks.
 *
 * Author: Caleb Miller
 *         caleb@caleb-miller.com
*/


let running = false;
let lastTimestamp = 0;
let listeners = new Set();


const Ticker = {};


// Will call function reference repeatedly once registered, passing elapsed time and a lag multiplier as parameters
Ticker.subscribe = function subscribe(callback) {
	if (typeof callback !== 'function') {
		throw new TypeError('Ticker.subscribe() requires a function reference passed for a callback.');
	}

	listeners.add(callback);

	// Start frame-loop lazily
	if (!running) {
		running = true;
		queueFrame();
	}

	// Return custom ubsubscribe handler
	return function unsubscribe() {
		listeners.delete(callback);

		// Stop frame-loop if there are no more listeners
		if (!listeners.size) {
			running = false;
		}
	};
};

// Queue up a new frame (calls frameHandler)
function queueFrame() {
	if (!running) return;

	if (window.requestAnimationFrame) {
		window.requestAnimationFrame(frameHandler);
	} else {
		window.webkitRequestAnimationFrame(frameHandler);
	}
}

function frameHandler(timestamp) {
	let frameTime = timestamp - lastTimestamp;
	lastTimestamp = timestamp;
	// make sure negative time isn't reported (first frame can be whacky)
	if (frameTime < 0) {
		frameTime = 17;
	}
	// - cap minimum framerate to 15fps[~68ms] (assuming 60fps[~17ms] as 'normal')
	else if (frameTime > 68) {
		frameTime = 68;
	}

	// fire custom listeners
	listeners.forEach(listener => listener.call(null, frameTime, frameTime / 16.67));

	// always queue another frame
	queueFrame();
}


export default Ticker;



// WEBPACK FOOTER //
// ./src/helpers/Ticker.js